import { createContext } from 'react'

export const ContactModalContext = createContext({});
export const ContactModalProvider = ContactModalContext.Provider;
export const ContactModalConsumer = ContactModalContext.Consumer;